export default __webpack_public_path__ + "static/media/caixajbl.4de8e56a.png";